import { HOME_PAGE } from '@dtx-company/true-common/src/constants/featureFlags'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useAssetsOrCodesPathname } from './useAssetsOrCodesPathname'
import { useFlowFeature } from './useFlowFeature/useFlowFeature'

export function useDefaultPathname(): Routes.ASSETS | Routes.CODES | Routes.HOME {
  const assetsOrCodesPathname = useAssetsOrCodesPathname()
  const [homepageFeatureFlag] = useFlowFeature(HOME_PAGE, { autoUpdate: true })
  return homepageFeatureFlag ? Routes.HOME : assetsOrCodesPathname
}
